import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const zhTranslations: PluginDefaultTranslationsObject = {
  $schema: './翻译-schema.json',
  'plugin-form-builder': {
    name: '名称（小写，无特殊字符）',
    add: '添加',
    allowedFileTypes: '允许的文件类型',
    allowedFileTypesDescription:
      '限制允许的文件类型（例如图像/*、应用程序/pdf）。留空以允许所有类型。',
    allowMultipleFiles: '允许多个文件',
    amountInCents: '金额以美分为单位',
    basePrice: '基本价格',
    bcc: '密件抄送',
    brand: '品牌',
    cc: '抄送',
    checkboxPlural: '复选框字段',
    checkboxSingular: '复选框',
    checkedByDefault: '默认勾选',
    chooseConfirmationType: '选择在提交表单后是显示页面消息还是重定向到其他页面。',
    condition: '条件',
    confirmationMessage: '确认信息',
    confirmationType: '确认类型',
    countryPlural: '乡村田野',
    countrySingular: '国家',
    creditCard: '信用卡',
    customURL: '自定义网址',
    datePlural: '日期字段',
    dateSingular: '日期',
    defaultValue: '默认值',
    divide: '划分',
    documentToLinkTo: '要链接到的文档',
    doesNotEqual: '不等于',
    emailFrom: '电子邮件发件人',
    emailPlural: '电子邮件字段',
    emailsDescription:
      '提交表单时发送自定义电子邮件。使用逗号分隔列表将同一封电子邮件发送给多个收件人。要引用此表单中的值，请用双大括号将该字段的名称括起来，即 {{firstName}}。您可以使用通配符 {{*}} 输出所有数据，并使用 {{*:table}} 将其格式化为电子邮件中的 HTML 表格。',
    emailSingular: '电子邮件',
    emailTo: '发送电子邮件至',
    equals: '等于',
    field: '领域',
    fields: '领域',
    fieldWidth: '字段宽度（百分比）',
    hasAnyValue: '有任何价值',
    internalLink: '内部链接',
    label: '标签',
    maxFileSize: '最大文件大小（字节）',
    maxFileSizeDescription: '最大文件大小（以字节为单位）。留空则无限制。',
    message: '留言',
    messageDescription: '输入应在此电子邮件中发送的消息。',
    messagePlural: '消息块',
    messageSingular: '留言',
    mimeType: 'MIME 类型',
    mimeTypePlural: 'MIME 类型',
    mimeTypeSingular: 'MIME 类型',
    multiply: '乘法',
    numberPlural: '数字字段',
    numberSingular: '数量',
    optionPlural: '选项',
    optionSingular: '选项',
    paymentFieldPlural: '付款字段',
    paymentFieldSingular: '付款方式',
    paymentProcessor: '支付处理器',
    paymentStatus: '状态',
    placeholder: '占位符',
    priceConditions: '价格条件',
    priceConditionsPlural: '价格条件',
    priceConditionsSingular: '价格条件',
    radioOptions: '无线电属性选项',
    radioPlural: '无线电场',
    radioSingular: '收音机',
    redirect: '重定向',
    replyTo: '回复',
    required: '必填',
    selectOptions: '选择选项',
    selectPlural: '选择字段',
    selectSingular: '选择',
    statePlural: '状态字段',
    stateSingular: '状态',
    staticValue: '静态值',
    subject: '主题',
    submitButton: '提交按钮标签',
    subtract: '减去',
    textareaPlural: '文本区域字段',
    textareaSingular: '文本区',
    textPlural: '文本字段',
    textSingular: '文字',
    title: '标题',
    token: '代币',
    uploadCollection: '上传收藏',
    uploadCollectionDescription: '选择要存储文件的上传集合',
    uploadFieldPlural: '上传字段',
    uploadFieldSingular: '上传',
    urlToRedirectTo: '要重定向到的 URL',
    value: '价值',
    valueOfField: '字段值',
    valueType: '值类型',
  },
}

export const zh: PluginLanguage = {
  dateFNSKey: 'zh-CN',
  translations: zhTranslations,
}
